/**
 * The type of user authentication used to start a conversation
 * @property {string} ANONYMOUS - Authentication with no confirmation of identity. Either by skipping other authentication steps or through a flow which uses no auth methods.
 * @property {string} MDN_SMS_OTP - Authentication via a code sent to the user's phone
 * @property {string} MDN_VOICE_OTP - Authentication via a code sent a voice call to the user's phone
 * @property {string} ASURION - Authentication via a given Asurion ID OAuth token
 * @readonly
 */
export const AuthenticationTypes = {
    ANONYMOUS: 'anonymous',
    MDN_SMS_OTP: 'mdn-sms-otp',
    MDN_VOICE_OTP: 'mdn-voice-otp',
    OAUTH: 'oauth',
} as const;

export type AuthenticationTypes = (typeof AuthenticationTypes)[keyof typeof AuthenticationTypes];

/**
 * Enum for the different outcomes of an OTP verification
 * @property {string} VERIFIED - OTP was verified successfully
 * @property {string} EXPIRED - OTP was expired, cannot be verified
 * @property {string} INVALID - OTP did not match the one sent to user
 * @property {string} MAX_ATTEMPTS - OTP for this transaction was attempted too many times
 * @property {string} OTHER - OTP verification failed for some other reason.
 * @readonly
 */
export const VerifyOtpOutcomes = {
    VERIFIED: 'verified',
    EXPIRED: 'expired',
    INVALID: 'invalid',
    MAX_ATTEMPTS: 'max-attempts-reached',
    OTHER: 'other-validation-error',
} as const;

export type VerifyOtpOutcomes = (typeof VerifyOtpOutcomes)[keyof typeof VerifyOtpOutcomes];
